import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EVENT_TYPE, EVENT_TYPE_COLOR } from './../utils';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { faUserClock } from '@fortawesome/free-solid-svg-icons';
import { faUserFriends } from '@fortawesome/free-solid-svg-icons';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { faHandsHelping } from '@fortawesome/free-solid-svg-icons';
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import { faMailBulk } from '@fortawesome/free-solid-svg-icons';
import { faFax } from '@fortawesome/free-solid-svg-icons';
import { faFileWord } from '@fortawesome/free-solid-svg-icons';
import { faUserCheck } from '@fortawesome/free-solid-svg-icons';
import { faPiggyBank } from '@fortawesome/free-solid-svg-icons';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';

function EventTypeIcon(props) {
  if (props.event.type === EVENT_TYPE['send-invoice'].name) {
    return(
      <FontAwesomeIcon icon={faFileInvoiceDollar} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['send-invoice'] }} />
    )
  }

  if (props.event.type === EVENT_TYPE['check-payment'].name) {
    return(
      <FontAwesomeIcon icon={faPiggyBank} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['check-payment'] }} />
    )
  }

  if (props.event.type === EVENT_TYPE['to-follow-up'].name) {
    return(
      <FontAwesomeIcon icon={faUserCheck} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['to-follow-up'] }} />
    )
  }

  if (props.event.type === EVENT_TYPE['vacancy'].name) {
    return(
      <FontAwesomeIcon icon={faFileWord} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['vacancy'] }} />
    )
  }

  if (props.event.type === EVENT_TYPE['to-bd'].name) {
    return(
      <FontAwesomeIcon icon={faFax} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['to-bd'] }} />
    )
  }

  if (props.event.type === EVENT_TYPE['in-out'].name) {
    return(
      <FontAwesomeIcon icon={faClipboardCheck} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['in-out'] }} />
    )
  }

  if (props.event.type === EVENT_TYPE['tob'].name) {
    return(
      <FontAwesomeIcon icon={faHandsHelping} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['tob'] }} />
    )
  }

  if (props.event.type === EVENT_TYPE['phonecall'].name) {
    return(
      <FontAwesomeIcon icon={faPhone} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['phonecall'] }} />
    )
  }

  if (props.event.type === EVENT_TYPE['interview-follow-up'].name) {
    return(
      <FontAwesomeIcon icon={faUserFriends} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['interview-follow-up'] }} />
    )
  }

  if (props.event.type === EVENT_TYPE['bd-call'].name) {
    return(
      <FontAwesomeIcon icon={faPhoneAlt} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['bd-call'] }} />
    )
  }

  if (props.event.type === EVENT_TYPE['cv-sent'].name) {
    return(
      <FontAwesomeIcon icon={faFileAlt} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['cv-sent'] }} />
    )
  }

  if (props.event.type === EVENT_TYPE['spec-cv-sent'].name) {
    return(
      <FontAwesomeIcon icon={faFile} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['spec-cv-sent'] }} />
    )
  }

  if (props.event.type === EVENT_TYPE['interview-arranged'].name) {
    return(
      <FontAwesomeIcon icon={faUserClock} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['interview-arranged'] }} />
    )
  }

  if (props.event.type === EVENT_TYPE['offer'].name) {
    return(
      <FontAwesomeIcon icon={faFileSignature} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['offer'] }} />
    )
  }

  if (props.event.type === EVENT_TYPE['bulk-emails'].name) {
    return(
      <FontAwesomeIcon icon={faMailBulk} style={{ fontSize: '16px', color: EVENT_TYPE_COLOR['bulk-emails'] }} />
    )
  }

}

export default EventTypeIcon;
